<template>
  <section class="section">
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <h1 class="title">Benutzerlog</h1>
      </div>
    </div>
    <v-data-table 
      :headers="headers" 
      :items="users" 
      :items-per-page="5" 
      class="elevation-1"></v-data-table>
  </section>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      allNews: [],
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Ort", value: "Ort" },
        { text: "Email", value: "Email" }
      ],
      userss: [
        {
          id: 1,
          name: "Shawna Dubbin",
          email: "sdubbin0@geocities.com",
          gender: "Male",
          title: "Assistant Media Planner"
        },
        {
          id: 2,
          name: "Odette Demageard",
          email: "odemageard1@spotify.com",
          gender: "Female",
          title: "Account Coordinator"
        },
        {
          id: 3,
          name: "Lonnie Izkovitz",
          email: "lizkovitz3@youtu.be",
          gender: "Female",
          title: "Operator"
        },
        {
          id: 4,
          name: "Thatcher Stave",
          email: "tstave4@reference.com",
          gender: "Male",
          title: "Software Test Engineer III"
        },
        {
          id: 5,
          name: "Clarinda Marieton",
          email: "cmarietonh@theatlantic.com",
          gender: "Female",
          title: "Paralegal"
        }
      ]
    };
  },
  computed: {
    users() {
      var key = "2334235";
      
      const { dispatch } = this.$store;
      var a = dispatch("users/getUser", { key });
      console.log(a);
      return [
        {
          id: 1,
          name: "Shawna Dubbin",
          email: "sdubbin0@geocities.com",
          gender: "Male",
          title: "Assistant Media Planner"
        },
        {
          id: 2,
          name: "Odette Demageard",
          email: "odemageard1@spotify.com",
          gender: "Female",
          title: "Account Coordinator"
        }
      ]      
    }
  },
  methods: {
    user() {
      this.key = "2334235";
      const { key } = this;
      const { dispatch } = this.$store;
      var a = dispatch("users/getUser", { key });
      console.log(a);
      return [
        {
          id: 1,
          name: "Shawna Dubbin",
          email: "sdubbin0@geocities.com",
          gender: "Male",
          title: "Assistant Media Planner"
        },
        {
          id: 2,
          name: "Odette Demageard",
          email: "odemageard1@spotify.com",
          gender: "Female",
          title: "Account Coordinator"
        }
      ]      
    }
  }
};
</script>
